import { Badge } from '@mantine/core';
import clsx from 'clsx';
import classes from './IngestionStatusBadge.module.css';

type IngestionStatusBadgeProps = {
  statut: string | null;
};

const IN_PROGRESS_STATUS = 'EN_COURS';
const ERROR_STATUS = 'ERREUR';

const getStatusColor = (statut: string): string => {
  if (statut === 'SUCCES') return 'green';
  if (statut === IN_PROGRESS_STATUS) return 'blue';
  if (statut === ERROR_STATUS) return 'red';
  return 'gray';
};

const IngestionStatusBadge = ({ statut }: IngestionStatusBadgeProps) => {
  if (!statut) {
    return '—';
  }

  const normalizedStatus = statut.toUpperCase();

  return (
    <Badge
      variant="light"
      color={getStatusColor(normalizedStatus)}
      className={clsx({ [classes.blink]: normalizedStatus === IN_PROGRESS_STATUS })}
    >
      {statut}
    </Badge>
  );
};

export default IngestionStatusBadge;
